function getSaleCollectionVisitedCookie() {
  var match = document.cookie.match(/(?:^|; )sale_collection_visited=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}

function getSaleOfferDiscountForVariant(variantId) {
  var discounts = window.__cmSaleOfferVariantDiscounts || {};
  var discount = discounts[String(variantId)];
  return discount > 0 ? discount : 0;
}

function applySaleOfferProperty(item) {
  if (!item || !item.id) return item;

  var discount = getSaleOfferDiscountForVariant(item.id);
  if (discount <= 0) return item;

  item.properties = item.properties || {};
  item.properties._SALEOFFER = discount + "%";
  return item;
}

// BFCM visitors (cookie bfcm_visited): _BFCMOFFER from window.__cmBfcmVariantDiscounts instead of _SALEOFFER.
// Discounted at checkout by the cellmetics-functions offer discount.
function applyBfcmOfferProperty(item) {
  if (!item || !item.id) return item;

  var discounts = window.__cmBfcmVariantDiscounts || {};
  var discount = discounts[String(item.id)];
  if (!(discount > 0)) return item;

  item.properties = item.properties || {};
  // bundle lines are priced by the bundle merge; lines that already carry an offer keep it
  var p = item.properties;
  if (p.Bundle || p._SALEOFFER || p._BFCMOFFER || p._OFFER || p._QTY_OFFER || p.OFFER) return item;
  item.properties._BFCMOFFER = discount + "%";
  return item;
}

function applySaleOfferToCartAddBody(body) {
  if (body && /(?:^|; )bfcm_visited=true/.test(document.cookie)) {
    if (Array.isArray(body.items)) {
      body.items = body.items.map(applyBfcmOfferProperty);
    } else if (body.id) {
      applyBfcmOfferProperty(body);
    }
    return body;
  }

  if (!body || getSaleCollectionVisitedCookie() !== "true") return body;

  if (Array.isArray(body.items)) {
    body.items = body.items.map(applySaleOfferProperty);
  } else if (body.id) {
    applySaleOfferProperty(body);
  }

  return body;
}

var saleCollectionOriginalFetch = window.fetch;

window.fetch = function (url, options) {
  try {
    var urlString = typeof url === "string" ? url : "";

    if (
      urlString.indexOf("/cart/add") !== -1 &&
      options &&
      typeof options.body === "string"
    ) {
      var body = JSON.parse(options.body);
      body = applySaleOfferToCartAddBody(body);
      options.body = JSON.stringify(body);
    }
  } catch (e) {}

  return saleCollectionOriginalFetch.apply(this, arguments);
};

if (window.jQuery) {
  jQuery.ajaxPrefilter(function (options) {
    if (!options.url || options.url.indexOf("/cart/add") === -1) return;

    try {
      var body = options.data;

      if (typeof body === "string") {
        body = JSON.parse(body);
      }

      body = applySaleOfferToCartAddBody(body);

      options.data = JSON.stringify(body);
      options.contentType = "application/json";
      options.processData = false;
    } catch (e) {}
  });
}
